// The part of a reward send that is not React.
//
// Extracted for the same reason summariseSend was: SendRewards imports base.js,
// which calls firebase.initializeApp at module load, so the screen itself
// cannot be imported into a test. Everything below decides whether a fan got
// their reward, and all of it used to sit inside the component where three
// separate mutations could pass the whole suite unnoticed.

import { retryWithBackoff } from './retry';

export function rewardPayload(user, reward) {
    return {
        "coupon_id": reward.id,
        "user_name": user.username,
        "user_id": user.userId,
        "email": user.email
    };
}

// Carrying the status is the whole point: without it isRetryableError sees a
// bare Error, cannot tell a rate limit from a bad request, and every 429 stops
// being retried — silently, because the send still "completes".
export function assertDelivered(response) {
    if (!response.ok) {
        const error = new Error(`HTTP ${response.status}`);
        error.status = response.status;
        throw error;
    }
    return response;
}

/**
 * Resolves to a result rather than throwing, so one bad address cannot abandon
 * the rest of the send.
 */
export async function sendOneReward(user, reward, { url, fetchImpl, retry = retryWithBackoff } = {}) {
    const post = fetchImpl || ((...args) => fetch(...args));
    try {
        await retry(
            async () => assertDelivered(await post(url, {
                method: "POST",
                body: JSON.stringify(rewardPayload(user, reward)),
                headers: {'Content-Type': 'application/json'}
            })),
            {
                // Shorter than the server-side defaults on purpose: an operator
                // is watching a progress counter, not a log.
                initialDelayMs: 500,
                maxDelayMs: 8000,
                operationName: `reward send to ${user.email}`
            }
        );
        return { ok: true, email: user.email };
    } catch (e) {
        return { ok: false, email: user.email, error: e.message };
    }
}

// A fan whose worker threw is still a fan who did not get their reward. Leaving
// the failures out here is what let a wholly failed send read as a success.
export function collectOutcomes(results, failures) {
    return (results || []).concat((failures || []).map(f => ({
        ok: false,
        email: f.item && f.item.email,
        error: f.error
    })));
}
